import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { EntityList } from "./EntityList";
import { EntityForm } from "./EntityForm";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export const EntityManagement = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedEntity, setSelectedEntity] = useState<any>(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSuccess = () => {
    setIsFormOpen(false);
    setSelectedEntity(null);
    setRefreshKey((prev) => prev + 1);
  };

  const handleEdit = (entity: any) => {
    setSelectedEntity(entity);
    setIsFormOpen(true);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold">Entity Management</h2>
          <p className="text-muted-foreground">
            Manage vehicle entities and their listing documents
          </p>
        </div>
        <Button onClick={() => setIsFormOpen(true)}>
          <Plus className="h-4 w-4 mr-2" />
          Add New Entity
        </Button>
      </div>

      <EntityList key={refreshKey} onEdit={handleEdit} />

      <Dialog open={isFormOpen} onOpenChange={setIsFormOpen}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>
              {selectedEntity ? "Edit Entity" : "New Entity"}
            </DialogTitle>
          </DialogHeader>
          <EntityForm
            entity={selectedEntity}
            onSuccess={handleSuccess}
            onCancel={() => {
              setIsFormOpen(false);
              setSelectedEntity(null);
            }}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};
